module.exports = __webpack_public_path__ + "static/media/micro.e95bd2c3.svg";